import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import SideBar from "./components/SideBar/SideBar";
import UserData from "./components/userLoged/userData";
import NotificationBell from "./components/notification/notification";
import { useSelector } from "react-redux";
import { DefaultReduxState } from "./store";
import AppRoutes from "./components/routes";
import Login from "./pages/Auth/login";
import ForgotPassword from "./components/Auth/resetPassword/resetPassword";
import ResetPassword from "./pages/Auth/resetPassword";

const App = () => {
  const [isSidebarActive, setIsSidebarActive] = useState<boolean>(false);
  const auth = useSelector((state: DefaultReduxState) => state.auth);

  const isActive = () => {
    setIsSidebarActive((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 480) {
        setIsSidebarActive(true);
      } else if (window.innerWidth <= 768) {
        setIsSidebarActive(true);
      } else {
        setIsSidebarActive(false);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Protected Routes */}
        {auth?._id ? (
          <Route
            path="/*"
            element={
              <div className="layout">
                <SideBar isActive={isActive} />
                <div className="loggedUser">
                  <NotificationBell />
                  <UserData />
                </div>
                <div
                  className={`layout__content ${
                    isSidebarActive ? "fullLayout" : ""
                  }`}
                >
                  <div className="layout__content-main">
                    <AppRoutes />
                  </div>
                </div>
              </div>
            }
          />
        ) : (
          <Route path="/*" element={<Navigate to="/login" />} />
        )}
      </Routes>
    </BrowserRouter>
  );
};

export default App;
